module.exports = __webpack_public_path__ + "static/media/PDF_EN_4.9a866cc7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/pdf/PDF_EN_4.pdf
// module id = 681
// module chunks = 0